import MembershipRepository from './MembershipRepository'
import ListingRepository from './newsletter/ListingRepoistory'
import SubscriptionRepository from './newsletter/SubscriptionRepoistory'
import PeopleRepository from './PeopleRepository'
import UserRepository from "./UserRepository";
import LoginRepository from "./LoginRepository";
import DonationRepository from "./DonationRepository";
import ExportRepository from "./ExportRepository";
import NewsRepository from "./NewsRepository";
import CampaignsRepository from "@/services/repositories/newsletter/CampaignsRepository";
import EventRepository from "./EventRepository";
import CampaignRepository from "@/services/repositories/CampaignRepository";

const repositories = {
    membership: MembershipRepository,
    newsletterListing: ListingRepository,
    newsletterSubscribe: SubscriptionRepository,
    newsletterCampaign: CampaignsRepository,
    people: PeopleRepository,
    user: UserRepository,
    login: LoginRepository,
    donation: DonationRepository,
    export: ExportRepository,
    news: NewsRepository,
    event: EventRepository,
    campaign: CampaignRepository,
};

export const RepositoryFactory = {
    get: name => repositories[name]
};
